export default __webpack_public_path__ + "static/media/shoes.59800a32.png";